// 3rd party imports
import * as React from 'react';
import { observer } from 'mobx-react';

// bernie
import { updateSearch } from 'bernie-core';

import { UitkSpacing } from 'uitk-react-spacing';
import { FlexDocumentDialog } from 'components/documents/flex-document-dialog';
import { useLocalization } from '@shared-ui/localization-context';
import { RouteComponentProps } from 'react-router';
import { useEffect } from 'react';
import { useStores } from '../../hooks';
import { withRouter } from 'react-router-dom';

export interface FlexDocumentProps extends RouteComponentProps {
  documentName: string;
}

const FlexDocumentComponent: React.FunctionComponent<FlexDocumentProps> = observer(
  ({ documentName, history, location }) => {
    const { context, uiStore } = useStores();
    const l10n = useLocalization();

    useEffect(() => {
      updateSearch({ history, location, newParams: { pwaDialog: 'flex-document-dialog' } });
    }, []);

    let url;
    let headerText;

    if (documentName) {
      const documentPrefix = uiStore?.flexDocumentPrefix;
      const locale = context.locale;
      url = `${documentPrefix}/lp/b/affhub/${documentName}?siteid=2055&locale=${locale}`;

      const headerName =
        {
          'terms-of-use': 'terms.page.title',
          'privacy-policy': 'privacy.policy.page.title',
          'cookie-policy': 'cookie.policy.page.title',
        }[documentName] || false;
      headerText = headerName ? l10n.formatText(headerName) : '';
    }

    return (
      <UitkSpacing className="container--small" padding={{ block: 'twelve' }}>
        <FlexDocumentDialog url={url} headerText={headerText} />
      </UitkSpacing>
    );
  },
);

export const FlexDocument = withRouter(FlexDocumentComponent);
